import Order from '~/models/read/Order';

export default $axios => () => ({
    async getExpertReviewPricing() {
        try {
            let response = await $axios.$get(`/api/v1/ordering/scribbr.com/simple`, { noAuthHeader: true });

            return response.find((el) => el.service.name === 'expert_review');
        } catch (error) {
            return [];
        }
    },

    async getStatus() {
        try {
            let response = await $axios.$get(`/api/v1/expert-review/status/`, { noAuthHeader: true });

            return response.data;
        } catch (error) {
            return [];
        }
    },

    uploadDocument(file) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('uploadfiletype[file]', file);

            $axios.$post(`/api/v1/expert-review/documents/`, formData, {
                ignoreLogout: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } }).then((response) => {
                resolve(new Order(response.data));
            })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async submit(formData) {
        let response = await $axios.post(`/api/v1/expert-review/`, formData, { withCredentials: true, ignoreLogout: true });
        return response;
    },
});
